var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 100,
    viewBox: "0 0 104 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-237 -3496)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "translate(239 3496)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 100,
    transform: "translate(239 3546)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.281,3548.266l17.5,17.5-17.5,17.5",
    transform: "translate(129.219 -19.766)",
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleche);
export default __webpack_public_path__ + "static/media/fleche.d068b2503a51bdaf4d166d69b6473a52.svg";
export { ForwardRef as ReactComponent };